'use strict';

angular.module('mean.projects').factory('projectBidService', ['$filter', 'ProjectBids', '$q', 'taskService', 'tradeCodeService', 'taskTotalsService', 'toaster', 'ProjectTasks',
    function ($filter, ProjectBids, $q, taskService, tradeCodeService, taskTotalsService, toaster, ProjectTasks) {

        var updateTaskRates = function (tasks, bid_tasks) {
            var outter_deferred = $q.defer();
            var outter_list = [];

            tasks.forEach(function (task) {
                var cp_task = $filter('filter')(bid_tasks, { _id: task.task_id }, true);
                if (cp_task.length !== 1)
                    alert('There is an issue getting the task');

                _.each(task.subtasks, function (sub, ij) {
                    sub.crew_rate = cp_task[0].subtasks[ij].crew_rate;
                    sub.piece_per_hour_rate = cp_task[0].subtasks[ij].piece_per_hour_rate;
                    sub.piece_rate = cp_task[0].subtasks[ij].piece_rate;
                    sub.unit = cp_task[0].subtasks[ij].unit;

                    _.each(sub.materials, function (mat, i) {
                        mat.supplier = cp_task[0].subtasks[ij].materials[i].supplier;
                    });

                    _.each(sub.equipment, function (eq, i) {
                        eq.supplier = cp_task[0].subtasks[ij].equipment[i].supplier;
                    });
                });

                outter_list.push(task);
            });

            $q.all(outter_list).then(function (results) {
                outter_deferred.resolve(results);
            });

            return outter_deferred.promise;
        };

        var getTradeString = function (trade) {
            return tradeCodeService.getName(trade);
        };

        var rebuildProjectBidFromBidTask = function (bid_task, original_bid_task) {
            bid_task.totals = bid_task.original_totals;

            //blow out all subtask/material information
            bid_task.subtasks = [];
            bid_task.materials = [];
            bid_task.equipment = [];

            //build the subtask array
            _.each(original_bid_task.subtasks, function (sub, ii) {
                bid_task.subtasks.push({
                    task_id: sub.task_id,
                    name: original_bid_task.subtasks[ii].name,
                    crew_rate: sub.crew_rate,
                    current_net_pay: sub.current_net_pay,
                    employee_benefits: sub.employee_benefits,
                    piece_per_hour_rate: sub.piece_per_hour_rate,
                    piece_rate: sub.piece_rate,
                    unit: sub.unit,
                    bid_hours: sub.bid_hours,
                    hours_allowed: sub.hours_allowed,
                    training_and_education: sub.training_and_education,
                    quantity: sub.quantity,
                    labor_total: sub.labor,
                    bid_mark_up: sub.bid_mark_up,
                    general_liability: sub.general_liability,
                    material_total: sub.material_total,
                    materials_subtotal: sub.materials_subtotal,
                    materials_dev_subtotal: sub.materials_dev_subtotal,
                    equipment_total: sub.equipment_total,
                    equipment_subtotal: sub.equipment_subtotal,
                    equipment_dev_subtotal: sub.equipment_dev_subtotal,
                    total: sub.total,
                    work_comp: sub.work_comp
                });

                _.each(sub.materials, function (mat, ij) {
                    bid_task.materials.push({
                        name: original_bid_task.subtasks[ii].materials[ij].name,
                        material_id: mat.material_id,
                        supplier: mat.supplier,
                        quantity: mat.quantity,
                        price_per_order: mat.price_per_order,
                        piece_per_size: mat.piece_per_size,
                        delivery_price: mat.delivery_price,
                        isInventory: mat.isInventory || false,
                        delivery_offset: original_bid_task.subtasks[ii].materials[ij].delivery_offset,
                        description: original_bid_task.subtasks[ii].materials[ij].description,
                        note: original_bid_task.subtasks[ii].materials[ij].note,
                        unit: original_bid_task.subtasks[ii].materials[ij].unit
                    });
                });

                _.each(sub.equipment, function (eq, ij) {
                    bid_task.equipment.push({
                        name: original_bid_task.subtasks[ii].equipment[ij].name,
                        equipment_id: eq.equipment_id,
                        supplier: eq.supplier,
                        quantity: eq.quantity,
                        price_per_order: eq.price_per_order,
                        piece_per_size: eq.piece_per_size,
                        delivery_price: eq.delivery_price,
                        delivery_offset: original_bid_task.subtasks[ii].equipment[ij].delivery_offset,
                        description: original_bid_task.subtasks[ii].equipment[ij].description,
                        note: original_bid_task.subtasks[ii].equipment[ij].note,
                        unit: original_bid_task.subtasks[ii].equipment[ij].unit
                    });
                });
            });

            return bid_task;
        };

        var buildProjectBids = function (tasks, bid, project_id) {
            var return_bids = [];
            var bid_tasks = bid.task_list;

            tasks.forEach(function (task, itr) {
                var cp_task = $filter('filter')(bid_tasks, { _id: task.task_id }, true)[0];
                if (!cp_task) {
                    alert('Could not get the task from the bid.task_list.  Call admin.');
                    return;
                }
                var sub_arr = [];
                var mat_arr = [];
                var eq_arr = [];

                //build the subtask array
                task.subtasks.forEach(function (sub, ii) {
                    sub_arr.push({
                        task_id: sub.task_id,
                        name: cp_task.subtasks[ii].name,
                        crew_rate: sub.crew_rate,
                        current_net_pay: sub.current_net_pay,
                        employee_benefits: sub.employee_benefits,
                        piece_per_hour_rate: sub.piece_per_hour_rate,
                        piece_rate: sub.piece_rate,
                        unit: sub.unit,
                        bid_hours: sub.bid_hours,
                        hours_allowed: sub.hours_allowed,
                        training_and_education: sub.training_and_education,
                        quantity: sub.quantity,
                        labor_total: sub.labor,
                        bid_mark_up: sub.bid_mark_up,
                        general_liability: sub.general_liability,
                        material_total: sub.material_total,
                        materials_subtotal: sub.materials_subtotal,
                        materials_dev_subtotal: sub.materials_dev_subtotal,
                        equipment_total: sub.equipment_total,
                        equipment_subtotal: sub.equipment_subtotal,
                        equipment_dev_subtotal: sub.equipment_dev_subtotal,
                        total: sub.total,
                        work_comp: sub.work_comp
                    });

                    sub.materials.forEach(function (mat, ij) {
                        mat_arr.push({
                            name: cp_task.subtasks[ii].materials[ij].name,
                            material_id: mat.material_id,
                            supplier: mat.supplier,
                            quantity: mat.quantity,
                            price_per_order: mat.price_per_order,
                            piece_per_size: mat.piece_per_size,
                            delivery_price: mat.delivery_price,
                            isInventory: mat.isInventory || false,
                            delivery_offset: cp_task.subtasks[ii].materials[ij].delivery_offset,
                            description: cp_task.subtasks[ii].materials[ij].description,
                            note: cp_task.subtasks[ii].materials[ij].note,
                            unit: cp_task.subtasks[ii].materials[ij].unit
                        });
                    });

                    sub.equipment.forEach(function (eq, ij) {
                        eq_arr.push({
                            name: cp_task.subtasks[ii].equipment[ij].name,
                            equipment_id: eq.equipment_id,
                            supplier: eq.supplier,
                            quantity: eq.quantity,
                            price_per_order: eq.price_per_order,
                            piece_per_size: eq.piece_per_size,
                            delivery_price: eq.delivery_price,
                            delivery_offset: cp_task.subtasks[ii].equipment[ij].delivery_offset,
                            description: cp_task.subtasks[ii].equipment[ij].description,
                            note: cp_task.subtasks[ii].equipment[ij].note,
                            unit: cp_task.subtasks[ii].equipment[ij].unit
                        });
                    });
                });

                console.log('Creating new project bid ' + cp_task.name + ' for plan ' + task.plan_code);
                var override = $filter('filter')(bid.overrides, {
                    'plan_code': task.plan_code, 'enabled': true
                }, true);

                var offset_total = 0;
                var mark_up = task.bid_mark_up
                //only adjust override total on the first task
                if (override.length === 1 && itr === 0) {
                    offset_total = override[0].amount - override[0].original_amount;
                    mark_up = override[0].amount;
                }

                var extra_liability = $filter('filter')(bid.extra_liability, {
                    'plan_code': task.plan_code, 'enabled': true
                }, true);

                if (extra_liability.length === 1 && itr === 0) {
                    task.bid_general_liability += extra_liability[0].amount;
                    task.total += extra_liability[0].amount;
                }

                var proBid = new ProjectBids({
                    task_name: cp_task.name,
                    trade: getTradeString(cp_task.trade),
                    project_id: project_id,
                    task_code: cp_task.trade + cp_task.task,
                    plan_code: task.plan_code,
                    days: 1.0,
                    hours: 8.0,
                    days_offset: task.task_id - 1,
                    task_id: task.task_id,
                    totals: {  //task totals computed during bid phase (during accepting)
                        total: task.total + offset_total,
                        labor: task.total_labor,
                        materials: task.total_materials,
                        materials_subtotal: task.materials_subtotal,
                        materials_dev_subtotal: task.materials_dev_subtotal,
                        equipment: task.total_equipment,
                        equipment_subtotal: task.equipment_subtotal,
                        equipment_dev_subtotal: task.equipment_dev_subtotal,
                        current_net_pay: task.total_current_net_pay,
                        general_liability: task.bid_general_liability,
                        mark_up: mark_up,
                        work_comp: task.work_comp,
                        hours_allowed: task.total_hours_allowed
                    },
                    subtasks: sub_arr,
                    materials: mat_arr,
                    equipment: eq_arr
                });

                return_bids.push(proBid);
            });

            return return_bids;
        }

        var applyCalculations = function (tasks, costs, overrides, view_obj) {
            taskTotalsService.getCalculations(tasks, costs);

            view_obj.bid_general_liability = tasks.bid_general_liability;
            view_obj.bid_total_labor = tasks.bid_total_labor;
            view_obj.bid_total_materials = tasks.bid_total_materials;
            view_obj.bid_materials_taxes = tasks.bid_materials_taxes;
            view_obj.bid_materials_subtotal = tasks.bid_materials_subtotal;
            view_obj.bid_total_equipment = tasks.bid_total_equipment;
            view_obj.bid_equipment_subtotal = tasks.bid_equipment_subtotal;
            view_obj.bid_equipment_taxes = tasks.bid_equipment_taxes;
            view_obj.bid_direct_labor = tasks.bid_direct_labor;
            view_obj.bid_mark_up = tasks.bid_mark_up;
            view_obj.bid_workers_comp = tasks.bid_workers_comp;
            view_obj.bid_payroll_taxes = tasks.bid_payroll_taxes;

            var inlist = [];

            if (tasks.length) {
                inlist = $filter('filter')(overrides,
                    { 'plan_code': tasks[0].plan }, true);
            } else {
                // inlist = $filter('filter')(overrides,
                //     {'plan_code': $scope.current_plan.item}, true);
                toaster.pop('error', 'task list issue', 'there is no task to get a plan code from');
            }

            if (inlist.length === 0) {
                view_obj.bid_mark_up = tasks.bid_mark_up;
                view_obj.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
            } else if (inlist.length === 1) {
                //so...we have an override here and need to adjust
                //the tasks that make up this plan to remove the amounts
                //until it is made up for
                var total_adjust = inlist[0].original_amount - inlist[0].amount;
                for (var i = 0; i < tasks.length; i++) {
                    if (tasks[i].bid_mark_up <= total_adjust) {
                        total_adjust -= tasks[i].bid_mark_up;
                        tasks[i].bid_mark_up = 0;
                    } else {
                        tasks[i].bid_mark_up -= total_adjust;
                        total_adjust = 0;
                        break;
                    }
                }

                tasks.bid_mark_up = inlist[0].amount;
                tasks.bid_overhead_and_profit = inlist[0].amount;
                tasks.bid_total -= inlist[0].original_amount - inlist[0].amount;
            }

            view_obj.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
            view_obj.bid_total_hours_allowed = tasks.bid_total_hours_allowed;
            view_obj.bid_direct_labor = tasks.bid_direct_labor;
            view_obj.bid_total = tasks.bid_total;

            return view_obj;
        };

        var buildProjectBidsFromPlans = function (project_id, bidder, plan_codes, view_obj) {
            var all_project_bid_tasks = [];

            //get the project tasks for my trade
            ProjectTasks.query({
                'project_id': project_id, 'trade': bidder.trade
            }, function (projTasks) {
                // if(projTasks.length > 0) {
                //     //might want to look at a way to just update
                //     //the ProjectTasks so things stay right
                //     toaster.pop('error', 'Lots Already Scheduled',
                //         'Please unschedule your lots to perform this task.');
                //     return;
                // }
                //var project_tasks = $filter('filter')(projTasks,)

                //projTasks will be all the project tasks no matter the revision
                //the only way to know if it's a revision is if the project_bid_id
                //is different for each of the same tasks
                console.log(projTasks);

                //get all the current project bids
                ProjectBids.query({
                    'project_id': project_id,
                    'trade': bidder.trade,
                    'latest': true
                }, function (projBids) {

                    //list of project tasks associated with the removed bids
                    var project_tasks = [];
                    _.each(projBids, function (bid) {
                        var items = $filter('filter')(projTasks, { 'project_bid_id': bid._id }, true);

                        _.each(items, function (item) {
                            project_tasks.push(item);
                        });
                    });

                    //this will remove the most current (latest) set of bids
                    //it will not remove old revisions.
                    ProjectBids.query({
                        'type': 'RemoveAllByProjectId',
                        'trade': bidder.trade,
                        'project_id': project_id
                    }, function (projBids) {
                    });

                    var trade = bidder.costs;

                    for (var i = 0; i < plan_codes.length; i++) {
                        var plan = plan_codes[i];
                        var task_list = $filter('filter')(bidder.bid, { plan_code: plan.item }, true);
                        var bid = bidder;

                        updateTaskRates(task_list, bid.task_list).then(function (tasks) {

                            //before applying the calcs, get the piece rates and stuff from the task list
                            var ret_view_obj = applyCalculations(tasks,
                                bidder.costs, bidder.overrides, view_obj);

                            var project_bids = buildProjectBids(
                                tasks, bid, project_id);

                            //save per plan
                            ProjectBids.bulkAdd(project_bids, function (results) {
                                _.each(results, function (result) {
                                    if (project_tasks.length > 0) {
                                        var items = $filter('filter')(project_tasks, {
                                            'task_code': result.task_code
                                        }, true);

                                        _.each(items, function (item) {
                                            item.project_bid_id = result._id;
                                            item.$update();
                                        });
                                    }
                                });

                                if (results[0])
                                    toaster.pop('success',
                                        'Project Bids Created',
                                        'Plan data ' + results[0].plan_code + ' saved to database');
                            });
                        });
                    }
                });
            });
        };

        var buildProjectBidsFromPlanAndVersion = function(
            project_id, bidder, plan, revision, removeBids) {
            var all_project_bid_tasks = [];

            //get the project tasks for my trade
            ProjectTasks.query({
                'project_id': project_id, 'trade': bidder.trade }, function(projTasks) {

                //projTasks will be all the project tasks no matter the revision
                //the only way to know if it's a revision is if the project_bid_id
                //is different for each of the same tasks
                console.log(projTasks);

                if(revision == 0) {
                    //get all the current project bids
                    ProjectBids.query({
                       'project_id': project_id,
                       'trade': bidder.trade,
                       'latest': true}, function(projBids) {

                        //list of project tasks associated with the removed bids
                        var project_tasks = [];
                        _.each(projBids, function(bid) {
                            var items = $filter('filter')(projTasks, {
                                'project_bid_id': bid._id}, true);

                            _.each(items, function(item) {
                                project_tasks.push(item);
                            });
                        });

                        //this will remove the most current (latest) set of bids
                        //it will not remove old revisions.
                        if(removeBids) {
                            ProjectBids.query({
                               'type': 'RemoveAllByProjectId', 
                               'trade': bidder.trade,
                               'project_id': project_id}, function(projBids) {
                            });
                        }

                        var trade = bidder.costs;

                        var task_list = $filter('filter')(bidder.bid, {
                        plan_code: plan }, true);
                        var bid = bidder;

                        updateTaskRates(task_list, bid.task_list).then(function(tasks) {

                            //before applying the calcs, get the piece rates and stuff from the task list
                            // var ret_view_obj = applyCalculations(tasks, 
                            //     bidder.costs, bidder.overrides, view_obj);
                            taskTotalsService.getCalculations(tasks, bidder.costs);

                            var project_bids = buildProjectBids(
                                tasks, bid, project_id);

                            // _.each(project_bids, function(bid) {
                            //     //bid.revision = revision;
                            //     bid.latest = true;
                            // });
                            //save per plan
                            ProjectBids.bulkAdd(project_bids, function(results) {
                                _.each(results, function(result) {
                                    if(project_tasks.length > 0) {
                                        var items = $filter('filter')(project_tasks, {
                                            'task_code': result.task_code }, true);
                                    
                                        _.each(items, function(item) {
                                            item.project_bid_id = result._id;
                                            item.$update();
                                        });
                                    }
                                });

                                if(results[0])
                                  toaster.pop('success', 
                                      'Project Bids Created', 
                                      'Plan data ' + results[0].plan_code + ' saved to database');
                            });
                        });
                    });
                } else {
                    //get all the current project bids
                    ProjectBids.query({
                       'project_id': project_id,
                       'trade': bidder.trade,
                       'revision': revision}, function(projBids) {

                        //list of project tasks associated with the removed bids
                        var project_tasks = [];
                        _.each(projBids, function(bid) {
                            var items = $filter('filter')(projTasks, {
                                'project_bid_id': bid._id}, true);

                            _.each(items, function(item) {
                                project_tasks.push(item);
                            });
                        });

                        //this will remove the most current (latest) set of bids
                        //it will not remove old revisions.
                        if(removeBids) {
                            ProjectBids.query({
                                'type': 'RemovePlanRevisionByProjectId', 
                                'trade': bidder.trade,
                                'project_id': project_id,
                                'plan_code': plan,
                                'revision': revision }, function(projBids) {

                                    //if(projBids.length == 0) {
                                        console.log(projBids.length + ' removed');
                                    //}
                            });
                        }

                        var trade = bidder.costs;

                        var task_list = $filter('filter')(bidder.bid, {
                        plan_code: plan }, true);
                        var bid = bidder;

                        updateTaskRates(task_list, bid.task_list).then(function(tasks) {

                            //before applying the calcs, get the piece rates and stuff from the task list
                            // var ret_view_obj = applyCalculations(tasks, 
                            //     bidder.costs, bidder.overrides, view_obj);
                            taskTotalsService.getCalculations(tasks, bidder.costs);

                            var project_bids = buildProjectBids(
                                tasks, bid, project_id);

                            _.each(project_bids, function(bid) {
                                bid.revision = revision;
                                bid.latest = false;
                            });
                            //save per plan
                            ProjectBids.bulkAdd(project_bids, function(results) {
                                _.each(results, function(result) {
                                    if(project_tasks.length > 0) {
                                        var items = $filter('filter')(project_tasks, {
                                            'task_code': result.task_code }, true);
                                    
                                        _.each(items, function(item) {
                                            item.project_bid_id = result._id;
                                            item.$update();
                                        });
                                    }
                                });

                                if(results[0])
                                  toaster.pop('success', 
                                      'Project Bids Created', 
                                      'Plan data ' + results[0].plan_code + ' saved to database');
                            });
                        });
                    });
                }
            });
        };

        var updateSupplierName = function (items, bid_items) {
            var deferred = $q.defer();
            var list = [];

            items.forEach(function (sub, ij) {
                sub.supplier = bid_items[ij].supplier;

                list.push(sub);
            });

            $q.all(list).then(function (results) {
                deferred.resolve(results);
            });

            return deferred.promise;
        };

        var getByProjectBidsByIdPlan = function (project, item) {
            var deferred = $q.defer();

            ProjectBids.query({
                'trade': project.trade,
                'latest': true,
                'plan_code': item.plan,
                'project_id': project._id
            }, function (project_bids) {
                deferred.resolve(project_bids);
            });

            return deferred.promise;
        };

        var getProjectBidsForPlans = function (projects) {
            var deferred = $q.defer();
            var list = [];
            var count = 0;
            var total = 0;
            _.each(projects, function (project) {
                //I'm sure there is a better way but this seems to work.
                //build the total amount of times i have to do a db query
                //and increment count every time it comes back.  defer
                //the list when count matches total.
                total += project.get_bids.length;
                _.each(project.get_bids, function (item) {
                    getByProjectBidsByIdPlan(project, item).then(function (results) {
                        _.each(results, function (result) {
                            list.push(result);
                        });
                        count++;
                    })
                        .then(function (data) {
                            if (count === total) {
                                deferred.resolve(list);
                            }
                        })
                        .catch(function (err) {
                            deferred.reject(err);
                        });
                });
            });

            return deferred.promise;
        }

        //this function will take a list of bids, a task,
        //and a project lot array and determine the bid
        //record that goes with the passed in task.
        //latest_revision is the revision number of the
        //latest revision
        // var bid_rev = $filter('unique')(bid_tasks, 'revision');
        // $scope.bid_revisions = bid_rev.length;
        var getProjectBidForTask = function (task, bids, lots, latest_revision) {
            var bid_records = null;

            var option_lot = $filter('filter')(lots, {
                'phase': task.phase, 'number': task.lot
            }, true)[0];
            var lot_bid_revision = $filter('filter')(option_lot.revisions, {
                'trade': task.trade
            }, true);

            if (lot_bid_revision && lot_bid_revision.length === 1) {
                lot_bid_revision = lot_bid_revision[0].revision;
            } else {
                lot_bid_revision = 1;
            }

            //the projectBids contain the revision for this
            //task.  We have to get the bid and then the cost info
            bid_records = $filter('filter')(bids, {
                'lot': task.lot, 'phase': task.phase, 'task_code': task.task_code
            }, true);

            if (bid_records.length === 0) {
                bid_records = $filter('filter')(bids, {
                    'plan_code': task.plan_code, 'task_code': task.task_code
                }, true);

                var removed = _.remove(bid_records, function (bid) {
                    return bid.lot && bid.phase;
                });

                if (lot_bid_revision === bid_records.length) {
                    bid_records = $filter('filter')(bid_records, {
                        'latest': true
                    }, true);
                } else {
                    bid_records = $filter('filter')(bid_records, {
                        'revision': lot_bid_revision
                    }, true);
                }

                if (bid_records.length !== 1) {
                    console.log('could not narrow down the bid record');
                }
            } else if (bid_records.length > 1) {
                if (lot_bid_revision === latest_revision) {
                    bid_records = $filter('filter')(bid_records, {
                        'latest': true
                    }, true);
                } else {
                    bid_records = $filter('filter')(bid_records, {
                        'revision': lot_bid_revision
                    }, true);
                }
            }

            return bid_records;
        }

        //with the recent changes to how options are handled, there
        //can be multiple bids that are for the same plan/task_code
        //because they are specific to a phase/lot. What makes it even
        //more fun is that lot may not be unique. We may have multiple
        //001's in the list but phase/lot is unique. So lets clean it up.
        var cleanBidRecordList = function (bids, lot) {
            //remove bid_tasks that have lot/phase defined but it's not mine
            _.remove(bids, function (bid) {
                if (!bid.phase && !bid.lot) { //is lot/phase defined
                    return false;
                }
                else if (bid.phase !== lot.phase) { //same phase
                    return true;
                } else {
                    return bid.lot !== lot.number; //same lot
                }
            });

            var result = [];
            //do I have lots defined that will override the default
            _.each(bids, function (bid) {
                if (bid.lot && bid.phase) {
                    var inlist = $filter('filter')(result, { 'task_code': bid.task_code }, true);
                    if (inlist.length === 0) { //not there so add it
                        result.push(bid);
                    } else if (inlist.length === 1) { //replace this bid record
                        var idx = result.indexOf(inlist[0]);
                        result.splice(idx, 1, bid);
                    } else {
                        console.log('this is a problem');
                    }
                } else {
                    var inlist = $filter('filter')(result, { 'task_code': bid.task_code }, true);
                    if (inlist.length === 0) {
                        result.push(bid);
                    }
                }
            });

            return result;
        };

        return {
            updateTaskRates: updateTaskRates,
            rebuildProjectBidFromBidTask: rebuildProjectBidFromBidTask,
            buildProjectBids: buildProjectBids,
            applyCalculations: applyCalculations,
            buildProjectBidsFromPlans: buildProjectBidsFromPlans,
            buildProjectBidsFromPlanAndVersion: buildProjectBidsFromPlanAndVersion,
            updateSupplierName: updateSupplierName,
            getProjectBidsForPlans: getProjectBidsForPlans,
            getProjectBidForTask: getProjectBidForTask,
            cleanBidRecordList: cleanBidRecordList
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/project-bid-service.js